import moment from "moment"
import getDateInterval from "./getDateInterval"

// Tog'a #342 (katalog #6024) / #438 «ha»: ro'yxatlarda sukut davri — «Сегодня». Bo'sh bo'lsa «За сегодня записей нет» + davrni kengaytirish
// (TableExtended / TodayEmpty). Hafta / oy — davrni kengaytirish tugmalari va qoldiqqa o'xshash ro'yxatlar (vitrina) uchun.
export type DefaultPeriod = "today" | "week" | "month"

export const periodInterval = (p: DefaultPeriod = "today") =>
  p === "week" ? getDateInterval(moment().startOf("week"), moment().endOf("week"))
    : p === "month" ? getDateInterval(moment().startOf("month"), moment().endOf("month"))
    : getDateInterval(moment(), moment())

/** URL'dagi davr aynan bugun (00:00 — 23:59) mi */
export const isTodayRange = (begin?: any, end?: any) => {
  if (!begin || !end) return false
  const b = moment(String(begin)), e = moment(String(end))
  return b.isValid() && e.isValid() && b.isSame(moment(), "day") && e.isSame(moment(), "day")
}
